import { SOURCE_DATA_TYPES } from './constants'

export const SOURCE_DATA_MUTATION_TYPES = Object.keys(SOURCE_DATA_TYPES).reduce(
  (acc, value) => ({ ...acc, [`SET_${value}`]: value }),
  {},
)

export const ROOT_MUTATION_TYPES = {
  SET_SOURCE_DATA: 'SET_SOURCE_DATA',
  SET_FORM_DATA: 'SET_FORM_DATA',
  SET_FORM_ERRORS: 'SET_FORM_ERRORS',
  SET_FORM_PENDING: 'SET_FORM_PENDING',
  SET_FORM_SUCCESSFUL_SUBMITTED: 'SET_FORM_SUCCESSFUL_SUBMITTED',
}

export const MUTATION_TYPES = {
  ADD_FORM_ERROR: 'ADD_FORM_ERROR',
  RESET_FORM_ERRORS: 'RESET_FORM_ERRORS',
  UPDATE_FORM_DATA: 'UPDATE_FORM_DATA',
  RESET_FORM_DATA: 'RESET_FORM_DATA',
  ADD_SKIPPED_STEP: 'ADD_SKIPPED_STEP',
  REMOVE_SKIPPED_STEP: 'REMOVE_SKIPPED_STEP',

  SET_BIKE_COMPONENT_DATA: 'SET_BIKE_COMPONENT_DATA',
  SET_COMPONENT_SELECTIONS: 'SET_COMPONENT_SELECTIONS',
  SET_CHECKBOX_SELECTIONS: 'SET_CHECKBOX_SELECTIONS',
  REMOVE_CHECKBOX_SELECTION: 'REMOVE_CHECKBOX_SELECTION',
  REMOVE_ALL_CHECKBOX_SELECTIONS: 'REMOVE_ALL_CHECKBOX_SELECTIONS',
}

export default {
  ...SOURCE_DATA_MUTATION_TYPES,
  ...ROOT_MUTATION_TYPES,
  ...MUTATION_TYPES,
}
